import { gql } from 'graphql-request';

export const REVOKE_OPERATIONAL_REQUEST = gql`
  mutation App5182dd71_Document($documentIds: [String!]!) {
    app5182dd71_OperationalRequest {
      terminate(documentIds: $documentIds) {
        status
        message {
          ru
          en
        }
      }
    }
  }
`;
